exports.CONTENT_TYPES = {
  JSON: 'application/json',
  TEXT: 'text/html',
  BLOB: 'blob',
  URI: 'uri',
};
